// extracted by mini-css-extract-plugin
module.exports = {"leftAlign":"FlexTicketRecommendedBadge-module__leftAlign___B3fzn"};